(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arx-collection-grid"] && !Shopify.designMode) return;
  try {
    
  class ArxCollectionGridFilters extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-filter-tab]'));
      this.grid = this.closest('.arx-collection-grid')?.querySelector('[data-grid]');
      if (!this.grid || !this.tabs.length) return;

      this.items = Array.from(this.grid.querySelectorAll('[data-filter]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.apply(tab.dataset.filterTab));
      });
    }

    apply(filter) {
      this.tabs.forEach((tab) => {
        const active = tab.dataset.filterTab === filter;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      this.items.forEach((item) => {
        const keys = (item.dataset.filter || 'all').trim().split(/\s+/);
        const show = filter === 'all' || keys.includes(filter);
        item.hidden = !show;
      });
    }
  }

  if (!customElements.get('arx-collection-grid-filters')) {
    customElements.define('arx-collection-grid-filters', ArxCollectionGridFilters);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arx-collections-explore"] && !Shopify.designMode) return;
  try {
    
  class ArxColExplore extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prev = this.querySelector('.arx-carousel-arrow--prev');
      this.next = this.querySelector('.arx-carousel-arrow--next');
      if (!this.track) return;

      this.interval = Number(this.dataset.interval || 5000);
      this.timer = null;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.prev?.addEventListener('click', () => this.scrollBy(-1));
      this.next?.addEventListener('click', () => this.scrollBy(1));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      window.addEventListener('resize', () => this.sync(), { passive: true });
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.mobileMq = window.matchMedia('(max-width: 749px)');
      this.mobileMq.addEventListener?.('change', () => this.start());
      window.addEventListener('resize', () => this.start(), { passive: true });

      this.sync();
      this.start();
    }

    canAutoplay() {
      if (this.reduced) return false;
      if (this.mobileMq?.matches) return this.hasAttribute('data-mobile-autoplay');
      return this.hasAttribute('data-autoplay');
    }

    disconnectedCallback() {
      this.stop();
    }

    getStep() {
      const card = this.track.querySelector('.arx-col-card');
      if (!card) return 0;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 6;
      return card.getBoundingClientRect().width + gap;
    }

    scrollBy(direction) {
      const step = this.getStep();
      if (!step) return;
      this.track.scrollBy({
        left: step * direction,
        behavior: this.reduced ? 'auto' : 'smooth',
      });
    }

    scrollNext() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth - 2);
      const atEnd = this.track.scrollLeft >= max;
      if (atEnd) {
        this.track.scrollTo({ left: 0, behavior: this.reduced ? 'auto' : 'smooth' });
      } else {
        this.scrollBy(1);
      }
    }

    sync() {
      if (!this.track) return;
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth - 2);
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max;
    }

    start() {
      this.stop();
      if (window.Shopify && window.Shopify.designMode) return;
      if (!this.canAutoplay()) return;
      if (this.track.scrollWidth <= this.track.clientWidth + 2) return;

      this.timer = window.setInterval(() => this.scrollNext(), this.interval);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  if (!customElements.get('arx-col-explore')) {
    customElements.define('arx-col-explore', ArxColExplore);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arx-hero"] && !Shopify.designMode) return;
  try {
    
  class ArxHero extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.arx-hero__slide'));
      this.pages = Array.from(this.querySelectorAll('.arx-hero__page'));
      this.index = 0;
      this.timer = null;
      this.interval = Number(this.dataset.interval || 6000);
      this.pages.forEach((button) => {
        button.addEventListener('click', () => this.go(Number(button.dataset.index)));
      });
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    go(next) {
      if (!this.slides.length) return;
      this.index = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      this.pages.forEach((button, i) => button.classList.toggle('is-active', i === this.index));
      this.start();
    }

    start() {
      this.stop();
      if (window.Shopify && window.Shopify.designMode) return;
      if (!this.hasAttribute('data-autoplay') || this.slides.length < 2) return;
      this.timer = window.setInterval(() => this.go(this.index + 1), this.interval);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  if (!customElements.get('arx-hero')) customElements.define('arx-hero', ArxHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arx-journey"] && !Shopify.designMode) return;
  try {
    
  class ArxJourney extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.dots = this.querySelectorAll('[data-dots] [data-index]');
      if (!this.track || !this.dots.length) return;
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.track.scrollTo({ left: this.track.clientWidth * Number(dot.dataset.index), behavior: 'smooth' });
        });
      });
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      this.sync();
    }

    sync() {
      const index = Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1));
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }
  }

  if (!customElements.get('arx-journey')) customElements.define('arx-journey', ArxJourney);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arx-product"] && !Shopify.designMode) return;
  try {
    
  class ArxGallery extends HTMLElement {
    connectedCallback() {
      this.thumbs = Array.from(this.querySelectorAll('.arx-gallery__thumb'));
      this.slides = this.querySelectorAll('.arx-gallery__slide');
      this.thumbsTrack = this.querySelector('[data-thumbs]');
      this.stagePrev = this.querySelector('[data-stage-prev]');
      this.stageNext = this.querySelector('[data-stage-next]');
      this.thumbPrev = this.querySelector('[data-thumb-prev]');
      this.thumbNext = this.querySelector('[data-thumb-next]');
      this.stage = this.querySelector('.arx-gallery__stage');

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.show(thumb.dataset.mediaId));
      });

      this.stagePrev?.addEventListener('click', () => this.step(-1));
      this.stageNext?.addEventListener('click', () => this.step(1));
      this.thumbPrev?.addEventListener('click', () => this.scrollThumbs(-1));
      this.thumbNext?.addEventListener('click', () => this.scrollThumbs(1));
      this.thumbsTrack?.addEventListener('scroll', () => this.syncThumbArrows(), { passive: true });

      const zoom = this.querySelector('[data-zoom]');
      const dialog = this.closest('.arx-pdp').querySelector('[data-zoom-dialog]');
      const frame = dialog.querySelector('[data-zoom-frame]');
      zoom?.addEventListener('click', () => {
        const active = this.querySelector('.arx-gallery__slide.is-active img');
        if (!active) return;
        frame.innerHTML = `<img src="${active.currentSrc || active.src}" alt="" width="1400" height="1400">`;
        dialog.showModal();
      });
      dialog.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close());

      this.syncNav();
      this.syncThumbArrows();
      this.bindStageSwipe();
      this.bindMobileThumbVerticalScroll();
      if (typeof ResizeObserver !== 'undefined' && this.thumbsTrack) {
        this._thumbResizeObserver = new ResizeObserver(() => this.syncThumbArrows());
        this._thumbResizeObserver.observe(this.thumbsTrack);
      }
    }

    bindStageSwipe() {
      if (!this.stage || this.thumbs.length < 2) return;

      const SWIPE_MIN = 48;
      let startX = 0;
      let startY = 0;
      let tracking = false;

      const onStart = (clientX, clientY) => {
        startX = clientX;
        startY = clientY;
        tracking = true;
      };

      const onEnd = (clientX, clientY) => {
        if (!tracking) return;
        tracking = false;
        const dx = clientX - startX;
        const dy = clientY - startY;
        if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy) * 1.15) return;
        this.step(dx < 0 ? 1 : -1);
      };

      this.stage.addEventListener(
        'touchstart',
        (event) => {
          if (event.touches.length !== 1) return;
          onStart(event.touches[0].clientX, event.touches[0].clientY);
        },
        { passive: true }
      );

      this.stage.addEventListener(
        'touchend',
        (event) => {
          const touch = event.changedTouches[0];
          if (!touch) return;
          onEnd(touch.clientX, touch.clientY);
        },
        { passive: true }
      );

      this.stage.addEventListener('touchcancel', () => {
        tracking = false;
      });

      let pointerId = null;
      this.stage.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse') return;
        pointerId = event.pointerId;
        onStart(event.clientX, event.clientY);
      });

      this.stage.addEventListener('pointerup', (event) => {
        if (pointerId !== event.pointerId) return;
        pointerId = null;
        onEnd(event.clientX, event.clientY);
      });

      this.stage.addEventListener('pointercancel', () => {
        pointerId = null;
        tracking = false;
      });
    }

    bindMobileThumbVerticalScroll() {
      const track = this.thumbsTrack;
      if (!track) return;

      const mobileMq = window.matchMedia('(max-width: 989px)');
      let startX = 0;
      let startY = 0;
      let lastY = 0;
      let axis = null;

      const isHorizontalThumbStrip = () =>
        mobileMq.matches && track.scrollWidth > track.clientWidth + 2;

      const reset = () => {
        axis = null;
        lastY = 0;
      };

      track.addEventListener(
        'touchstart',
        (event) => {
          if (!isHorizontalThumbStrip() || event.touches.length !== 1) return;
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
          lastY = startY;
          axis = null;
        },
        { passive: true }
      );

      track.addEventListener(
        'touchmove',
        (event) => {
          if (!isHorizontalThumbStrip() || event.touches.length !== 1) return;
          const touch = event.touches[0];
          const dx = touch.clientX - startX;
          const dy = touch.clientY - startY;

          if (axis === null) {
            if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
            axis = Math.abs(dy) > Math.abs(dx) ? 'y' : 'x';
          }

          if (axis === 'y') {
            event.preventDefault();
            const delta = touch.clientY - lastY;
            lastY = touch.clientY;
            window.scrollBy(0, delta);
          }
        },
        { passive: false }
      );

      track.addEventListener('touchend', reset, { passive: true });
      track.addEventListener('touchcancel', reset, { passive: true });
    }

    activeIndex() {
      return this.thumbs.findIndex((thumb) => thumb.classList.contains('is-active'));
    }

    step(direction) {
      const index = this.activeIndex();
      const next = this.thumbs[index + direction];
      if (!next) return;
      this.show(next.dataset.mediaId);
    }

    scrollThumbs(direction) {
      if (!this.thumbsTrack) return;
      const sample = this.thumbsTrack.querySelector('.arx-gallery__thumb');
      const styles = sample ? getComputedStyle(this.thumbsTrack) : null;
      const gap = styles ? parseFloat(styles.rowGap || styles.gap || '0') || 0 : 0.65;
      const step = sample ? sample.offsetHeight + gap : 72;
      const stepX = sample ? sample.offsetWidth + gap : 72;
      const vertical = this.thumbsTrack.scrollHeight > this.thumbsTrack.clientHeight + 2;
      if (vertical) {
        this.thumbsTrack.scrollBy({ top: step * direction, behavior: 'smooth' });
      } else {
        this.thumbsTrack.scrollBy({ left: stepX * direction, behavior: 'smooth' });
      }
    }

    syncNav() {
      const index = this.activeIndex();
      const last = this.thumbs.length - 1;
      if (this.stagePrev) this.stagePrev.disabled = index <= 0;
      if (this.stageNext) this.stageNext.disabled = index >= last || last < 0;
    }

    syncThumbArrows() {
      if (!this.thumbsTrack || !this.thumbPrev || !this.thumbNext) return;
      const vertical = this.thumbsTrack.scrollHeight > this.thumbsTrack.clientHeight + 2;
      const horizontal = this.thumbsTrack.scrollWidth > this.thumbsTrack.clientWidth + 2;
      const overflow = vertical || horizontal;
      this.thumbPrev.hidden = !overflow;
      this.thumbNext.hidden = !overflow;
      if (!overflow) return;

      if (vertical) {
        this.thumbPrev.disabled = this.thumbsTrack.scrollTop <= 2;
        this.thumbNext.disabled =
          this.thumbsTrack.scrollTop >= this.thumbsTrack.scrollHeight - this.thumbsTrack.clientHeight - 2;
      } else {
        this.thumbPrev.disabled = this.thumbsTrack.scrollLeft <= 2;
        this.thumbNext.disabled =
          this.thumbsTrack.scrollLeft >= this.thumbsTrack.scrollWidth - this.thumbsTrack.clientWidth - 2;
      }
    }

    show(id) {
      const match = (node) => node.dataset.mediaId === id || node.dataset.imageId === id;
      this.thumbs.forEach((thumb) => thumb.classList.toggle('is-active', match(thumb)));
      this.slides.forEach((slide) => slide.classList.toggle('is-active', match(slide)));
      this.syncNav();
      const activeThumb = this.querySelector('.arx-gallery__thumb.is-active');
      activeThumb?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      requestAnimationFrame(() => this.syncThumbArrows());
    }
  }

  class ArxTabs extends HTMLElement {
    connectedCallback() {
      this.buttons = this.querySelectorAll('[data-tab]');
      this.panels = this.querySelectorAll('[data-panel]');
      this.buttons.forEach((button) => button.addEventListener('click', () => this.open(button.dataset.tab)));
    }

    open(name) {
      this.buttons.forEach((button) => {
        const active = button.dataset.tab === name;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        const active = panel.dataset.panel === name;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    }
  }

  if (!customElements.get('arx-gallery')) customElements.define('arx-gallery', ArxGallery);
  if (!customElements.get('arx-tabs')) customElements.define('arx-tabs', ArxTabs);

  function arxInitProduct(root) {
    const json = root.querySelector('[data-product-json]');
    if (!json) return;
    const product = JSON.parse(json.textContent);
    const form = root.querySelector('[data-type="add-to-cart-form"]');
    const variantInput = root.querySelector('[ref="variantId"]') || root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-price]');
    const compareEl = root.querySelector('[data-compare]');
    const discountEl = root.querySelector('[data-discount]');
    const stockEl = root.querySelector('[data-stock]');
    const addBtn = root.querySelector('[ref="addToCartButton"]');
    const addContainer = root.querySelector('add-to-cart-component');
    const gallery = root.querySelector('arx-gallery');
    const soldOutText = root.dataset.soldOutText || 'Sold out';

    const money = (cents) => {
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: product.price_currency || undefined }).format(cents / 100);
      } catch (error) {
        return `₹${Math.round(cents / 100)}`;
      }
    };

    const selected = () => {
      const options = [];
      form?.querySelectorAll('input[data-option-position]:checked').forEach((input) => {
        const position = Number(input.dataset.optionPosition);
        if (!Number.isNaN(position) && position > 0) {
          options[position - 1] = input.value;
        }
      });
      return options;
    };

    const findVariant = () => {
      const options = selected();
      const hasSelection = options.some((value) => value);
      if (!hasSelection) return product.variants[0];
      return product.variants.find((variant) =>
        variant.options.every((value, index) => options[index] === value)
      );
    };

    const showVariantGallery = (variant) => {
      if (!gallery || !variant) return;
      const variantId = String(variant.id);
      const slides = gallery.querySelectorAll('.arx-gallery__slide[data-media-id]');
      for (const slide of slides) {
        const linkedIds = (slide.dataset.variantIds || '').split(',').filter(Boolean);
        if (linkedIds.includes(variantId)) {
          gallery.show(slide.dataset.mediaId);
          return;
        }
      }
      if (variant.featured_media?.id) {
        gallery.show(String(variant.featured_media.id));
        return;
      }
      if (variant.featured_image?.id) {
        gallery.show(String(variant.featured_image.id));
      }
    };

    const update = () => {
      const variant = findVariant();
      if (!variant || !variantInput) return;
      variantInput.value = variant.id;
      if (priceEl && variant.price) priceEl.textContent = money(variant.price);

      const compareAt = variant.compare_at_price;
      const onSale = compareAt && variant.price && compareAt > variant.price;
      if (compareEl) {
        if (onSale) {
          compareEl.textContent = money(compareAt);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (discountEl) {
        if (onSale) {
          const pct = Math.round(((compareAt - variant.price) * 100) / compareAt);
          discountEl.textContent = `${pct}% OFF`;
          discountEl.hidden = false;
        } else {
          discountEl.hidden = true;
        }
      }
      form?.querySelectorAll('fieldset').forEach((set) => {
        const checked = set.querySelector('input:checked');
        const label = set.querySelector('[data-option-label]');
        if (checked && label) label.textContent = checked.value;
        set.querySelectorAll('.arx-option__item').forEach((item) => {
          item.classList.toggle('is-selected', item.querySelector('input')?.checked);
        });
      });
      if (stockEl) {
        stockEl.classList.toggle('is-out', !variant.available);
        stockEl.innerHTML = variant.available
          ? `<span class="arx-buy__dot"></span>${stockEl.dataset.ready || 'In stock - Ships within 24 hours.'}`
          : soldOutText;
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (addContainer?.disable && addContainer?.enable) {
        if (variant.available) addContainer.enable();
        else addContainer.disable();
      }
      showVariantGallery(variant);
    };

    if (stockEl) stockEl.dataset.ready = stockEl.textContent.replace(/^\s+/, '').replace(/●|•/g, '').trim();

    root.querySelector('[data-scroll-size-guide]')?.addEventListener('click', () => {
      document.getElementById('size-guide')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    form?.addEventListener('change', update);
    form?.addEventListener('input', (event) => {
      if (event.target.matches('input[data-option-position]')) update();
    });
    update();
  }

  document.querySelectorAll('[data-product-section]').forEach(arxInitProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arx-reels"] && !Shopify.designMode) return;
  try {
    
  class ArxReels extends HTMLElement {
    connectedCallback() {
      this.isDown = false;
      this.startX = 0;
      this.scrollLeft = 0;
      this.addEventListener('pointerdown', (event) => {
        this.isDown = true;
        this.classList.add('is-dragging');
        this.startX = event.pageX - this.offsetLeft;
        this.startScroll = this.scrollLeft;
      });
      this.addEventListener('pointerleave', () => this.endDrag());
      this.addEventListener('pointerup', () => this.endDrag());
      this.addEventListener('pointermove', (event) => {
        if (!this.isDown) return;
        event.preventDefault();
        const walk = (event.pageX - this.offsetLeft - this.startX) * 1.2;
        this.scrollLeft = this.startScroll - walk;
      });

      this.dialog = this.closest('.arx-reels').querySelector('dialog');
      this.frame = this.dialog.querySelector('[data-frame]');
      this.querySelectorAll('.arx-reel__trigger').forEach((button) => {
        button.addEventListener('click', () => this.open(button));
      });
      this.dialog.querySelector('[data-close]').addEventListener('click', () => this.close());
      this.dialog.addEventListener('close', () => {
        this.frame.innerHTML = '';
      });
    }

    endDrag() {
      this.isDown = false;
      this.classList.remove('is-dragging');
    }

    open(button) {
      const url = button.dataset.video || '';
      let embed = '';
      if (url.includes('youtube.com') || url.includes('youtu.be')) {
        const id = url.includes('v=') ? url.split('v=')[1].split('&')[0] : url.split('/').pop();
        embed = `<iframe src="https://www.youtube.com/embed/${id}?autoplay=1" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
      } else if (url.includes('vimeo.com')) {
        const id = url.split('/').pop();
        embed = `<iframe src="https://player.vimeo.com/video/${id}?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
      } else if (url) {
        embed = `<video src="${url}" controls autoplay playsinline></video>`;
      } else {
        embed = `<img src="${button.querySelector('img')?.src || ''}" alt="">`;
      }
      this.frame.innerHTML = embed;
      this.dialog.showModal();
    }

    close() {
      this.dialog.close();
    }
  }

  if (!customElements.get('arx-reels')) customElements.define('arx-reels', ArxReels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arx-trust-bar"] && !Shopify.designMode) return;
  try {
    
  class ArxTrust extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.dots = this.querySelectorAll('[data-dots] [data-index]');
      if (!this.track || !this.dots.length) return;
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.track.scrollTo({ left: this.track.clientWidth * Number(dot.dataset.index), behavior: 'smooth' });
        });
      });
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      this.sync();
    }

    sync() {
      const index = Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1));
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    }
  }

  if (!customElements.get('arx-trust')) customElements.define('arx-trust', ArxTrust);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
